import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FlashCard = makeShortcode("FlashCard");
const Prompt = makeShortcode("Prompt");
const Answer = makeShortcode("Answer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Questions: Understanding how to access lists`}</h1>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`How many elements are in this list? `}</p>
        <p><inlineCode parentName="p">{`todo = ['eat', 'sleep', 'play a game']`}</inlineCode></p>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`This list contains three elements. Each one of them is of the type string.`}</p>
      </Answer>
    </FlashCard>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`What index would we use to access the item 'sleep' in this list? `}</p>
        <p><inlineCode parentName="p">{`todo = ['eat', 'sleep', 'play a game']`}</inlineCode></p>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`This is a tricky one! Because list indexing starts at `}<strong parentName="p">{`0`}</strong>{` in Python and most other programming languages, the second element ("sleep") is accessed using the index `}<strong parentName="p">{`1`}</strong>{`, like this: `}<inlineCode parentName="p">{`todo[1]`}</inlineCode></p>
      </Answer>
    </FlashCard>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`Oops, something went wrong when creating this list. Can you spot the error? `}</p>
        <p><inlineCode parentName="p">{`vacation_packing_list = {'shades', 'swimsuit', 'sunscreen']`}</inlineCode></p>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`This list was created using mismatched brackets. The syntax for a list in Python uses only `}<strong parentName="p">{`square brackets`}</strong>{`, so we can fix this line of code by changing it to `}</p>
        <p><inlineCode parentName="p">{`vacation_packing_list = ['shades', 'swimsuit', 'sunscreen']`}</inlineCode></p>
      </Answer>
    </FlashCard>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`Negative list indexing is a powerful tool that we can use to access a list `}<strong parentName="p">{`backwards`}</strong>{`. What list element are we accessing in the following code snippet? `}</p>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`temp_data = {45, 49, 32, 36, 41]
temp_yesterday = temp_data[-2]
`}</code></pre>
      </Prompt>
      <Answer mdxType="Answer">
        <p><inlineCode parentName="p">{`temp_yesterday`}</inlineCode>{` will be equal to the value 36.`}</p>
      </Answer>
    </FlashCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      